import { useEffect, useMemo } from "react";

import { useEditor, useNode } from "@craftjs/core";
import { debounce } from "lodash";

import { useSharedProp } from "../utils/tailwindConfig/hooks";

export default function SharedProperties({ name, type, overrideType }) {
  useSharedProperties(type, overrideType)

  return <div>{name}</div>
}

function useSharedProperties(type, overrideType) {
  const typeName = overrideType || type
  const { id: currentNodeId, properties } = useNode(({ id, data: { props: { properties } } }) => ({ id, properties }));

  const { query, actions: { history: { merge } } } = useEditor();
  const { setProp } = useMemo(() => merge(), [merge]);
  useSharedProp(`${type}.properties`, properties)

  const setPropsDebounced = useMemo(() => debounce(() => {
    if (!properties) {
      return;
    }
    const nodes = Object.entries(query.getNodes())

    for (const [nodeId, { data }] of nodes) {
      if (nodeId !== currentNodeId && data.name === typeName) {
        setProp(nodeId, props => {
          Object.assign(props.properties, properties);
        });
      }
    }
  }, 100), [setProp, properties, currentNodeId, query, typeName])

  useEffect(() => {
    setPropsDebounced()
  }, [setPropsDebounced]);
}
